import * as types from './actionTypes';

const initialState = {
	collapsed: true,
	transitioning: false,
	selectStoreOpen: false,
	changePasswordOpen: false,
	errorOpen: false
};

export default function reducer(state = initialState, action = {}) {
	switch(action.type) {
		case types.NAV_BAR_TOGGLE: {
			return {
				...state,
				collapsed: !state.collapsed,
				transitioning: true
			};
		}
		case types.NAV_BAR_CLOSE: {
			return {
				...state,
				collapsed: true,
				transitioning: true
			};
		}
		case types.NAV_BAR_TRANSITIONED: {
			return {
				...state,
				transitioning: false
			};
		}
		case types.SHOW_SELECT_STORE_MODAL: {
			return {
				...state,
				selectStoreOpen: true
			};
		}
		case types.HIDE_SELECT_STORE_MODAL: {
			return {
				...state,
				selectStoreOpen: false
			};
		}
		case types.SHOW_CHANGE_PASSWORD_MODAL: {
			return {
				...state,
				changePasswordOpen: true
			};
		}
		case types.HIDE_CHANGE_PASSWORD_MODAL: {
			return {
				...state,
				changePasswordOpen: false
			};
		}
		case types.SHOW_ERROR_MODAL: {
			return {
				...state,
				errorOpen: true
			};
		}
		case types.HIDE_ERROR_MODAL: {
			return {
				...state,
				errorOpen: false
			};
		}
		default:
			return state;
	}
}




/** WEBPACK FOOTER **
 ** ./src/modules/navbar/reducer.js
 **/